"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultMyPropertyTranslateState = {
    "myListingTitle": "My Listings",
    "myListingCaption": "Manage my property listings on OKAY.COM",
    "myViewingsTitle": "My Viewings",
    "myViewingCaption": "Manage my viewing properties on OKAY.COM",
    "myViewingEmpty": "You don't have any viewings with OKAY.COM yet",
    "myListingEmpty": "You don't have any listing on OKAY.COM yet",
    "documentEmpty": "You don't have any document yet",
    "reportSold": "Report Sold",
    "reportLeased": "Report Leased",
    "reportSoldLeased": "Report Sold / Leased",
    "searchPlaceholder": "Enter Keyword / District / Building / Address",
    "reportSoldSoldPrice": "Sale Price (eg. 12M)",
    "reportSoldLeasePrice": "Lease Price (eg. 30K)",
    "reportSoldSoldDate": "Sold Date (mm/dd/yyyy)",
    "reportSoldAgency": "Agency (eg. Midland)",
    "reportSoldSkip": "Skip",
    "reportSoldCancel": "Cancel",
    "reportSoldSubmit": "Submit",
    "sortPropertyIdDesc": "Property ID (High to Low)",
    "sortPropertyIdAsc": "Property ID (Low to High)",
    "sortListingPriceDesc": "Listing Price (High to Low)",
    "sortListingPriceAsc": "Listing Price (Low to High)",
    "sortBuildingNameDesc": "Building Name (Z-A)",
    "sortBuildingNameAsc": "Building Name (A-Z)",
};
exports.default = defaultMyPropertyTranslateState;
